function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* --------------------------------------------------
Import modules
-------------------------------------------------- */

import Equalizer from '@meteora-digital/equalizer';

/* --------------------------------------------------
Equalizer
-------------------------------------------------- */

var timeouts = {};
window.equalizers = {};
window.equalize = function () {
  clearTimeout(timeouts['equalize']);
  timeouts['equalize'] = setTimeout(function () {
    for (var key in window.equalizers) {
      if (Object.hasOwnProperty.call(window.equalizers, key)) {
        window.equalizers[key].update();
      }
    }
  }, 100);
};
window.addEventListener('scripts-loaded', function () {
  return window.equalize();
});
var index = 0;
var addEvents = function addEvents(Controller, container, before) {
  Controller.on(before, function () {
    container.style.height = container.clientHeight + 'px';
  });
  Controller.on('resize', function () {
    container.style.height = '';
  });
};
_toConsumableArray(document.querySelectorAll('[data-equalize]')).forEach(function (container) {
  var ID = container.getAttribute('data-equalize');
  // Set up the equalizer settings
  var settings = {
    container: container,
    identifiers: ID,
    rows: true
  };
  if (window.equalizers[ID]) ID = "".concat(ID, "-").concat(index);
  window.equalizers[ID] = new Equalizer(settings);
  addEvents(window.equalizers[ID], container, 'beforeUpdate');
  index += 1;
});
_toConsumableArray(document.querySelectorAll('[data-match-height]')).forEach(function (container) {
  var ID = container.getAttribute('data-match-height');
  // Set up the equalizer settings
  var settings = {
    container: container,
    identifiers: ID,
    rows: false
  };
  if (window.equalizers[ID]) ID = "".concat(ID, "-").concat(index);
  window.equalizers[ID] = new Equalizer(settings);
  addEvents(window.equalizers[ID], container, 'beforeResize');
  index += 1;
});